import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { getAllArchivedJobsForCompany } from '../../../../../data/listings';
import JobDashboardCard from '../Component/JobDashboardCard/JobDashboardCard';

const ArchivedJobs = ({ id }: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [jobs, setjobs] = useState([]);

    const toggleDropdown = async () => {
        if (!isOpen) {
            setIsLoading(true);
            try {
                const jobsData = await getAllArchivedJobsForCompany(id);
                setjobs(jobsData);
            } catch (err) {
                console.error("Error fetching archived jobs", err);
            }
            setIsLoading(false);
        }
        setIsOpen((prev: any) => !prev);
    };


    return (
        <div className="w-full bg-gray-200 rounded-md">
            <div className="flex py-3 px-2 justify-between items-center">
                <div className='text-instant-teams-blue-Main font-semibold text-[18px]'>Archived Jobs</div>

                <button onClick={toggleDropdown} className="text-gray-700 hover:text-black transition-all duration-200">
                    <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                </button>
            </div>

            {/* Optional: Show content when open */}
            {isOpen && (
                <div className="p-2 ">
                    {isLoading ? (
                        <div className="text-center py-4">Loading archived jobs...</div>
                    ) : jobs.length > 0 ? (
                        <div className='w-full mt-4 grid grid-cols-3 gap-4'>
                            {jobs.map((j_data: any) => (
                                <JobDashboardCard key={j_data.id} jobData={j_data} /> 
                            ))}
                        </div>
                    ) : (
                        <div className="flex w-full justify-center items-center py-4">
                            <p className="text-instant-teams-blue-Main text-lg">
                                There are no archived jobs
                            </p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ArchivedJobs;
